import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  messagesDataList: null,     //- 重要訊息列表
  messageBankList: null,      //- 重要訊息銀行列表
  messagesInfo: null,         //- 重要訊息內容
};

// getters
const getters = {};

// actions
const actions = {
  //- 取得重要訊息列表
  index({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/important-messages`,{
      params: data
    })
      .then( res => {
        commit('setMessagesDataList', res.data);
      });
  },
  //- 取得重要訊息的銀行列表
  getMessageBankList({commit}) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/important-message/bank-options`)
      .then( res => {
        commit('setMessageBankList', res.data);
      });
  },
  //- 取得重要訊息內容
  getMessageInfo({commit}, message_id) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/important-message/${message_id}`)
      .then( res => {
        commit('setMessagesDetailInfo', res.data);
      });
  },
};

// mutations
const mutations = {
  //- 取得重要訊息列表
  setMessagesDataList(state, data) {
    Vue.set(state, 'messagesDataList', data.data.data);
  },
  //- 重要訊息的銀行列表
  setMessageBankList(state, data) {
    Vue.set(state, 'messageBankList', data.data.data);
  },
  //- 取得重要訊息內容
  setMessagesDetailInfo(state, data) {
    Vue.set(state, 'messagesInfo', data.data.data);
  },
  //- 重置重要訊息內容
  resetMessageInfo(state) {
    Vue.set(state, 'messagesInfo', null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};